import clsx from "clsx";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ExpenserTriangle from "../ExpenserTriangle/ExpenserTriangle";
import useMainFilter from "../../hooks/useMainFilter";
import { ICON_SIZES } from "../../helpers/constants";
import useMobile from "../../hooks/useMobile";

interface ILoginLogo {
  rotate?: boolean;
}

const SCROLL_TRIGGER = 50;

const LoginLogo: React.FC<ILoginLogo> = ({ rotate = false }) => {
  const { setMainFilter } = useMainFilter();
  const { isMobile } = useMobile();
  const [isScrolled, setIsScrolled] = useState(false);

  return (
    <Link
      to="/"
      className={clsx([
        "z-[1000]",
        "flex",
        "flex-row",
        "items-center",
        "gap-1",
        "transition-all",
        "duration-300",
        "fixed",
        "md:relative",
        "md:right-auto",
        "md:top-auto",
        "top-6",
        "right-10",
        "px-4",
        "py-2",
        "bg-transparent",
      ])}
    >
      <ExpenserTriangle
        size={isMobile ? ICON_SIZES.SM : ICON_SIZES.XL}
        className={clsx(["transition-all", "duration-300", "text-red-600"])}
      />
      <h1
        className={clsx([
          "font-normal",
          "transition-all",
          "duration-300",
          "text-2xl",
          "md:text-5xl",
          "flex",
          "flex-row",
          "items-end",
        ])}
      >
        <span>eXpenser</span>
        <div
          className={clsx([
            "text-xs",
            "text-red-500",
            "inline-flex",
            "uppercase",
            "items-end",
            "md:items-start",
            "pb-1",
            "md:pb-1",
          ])}
        >
          .net
        </div>
      </h1>
    </Link>
  );
};

export default LoginLogo;
